import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { getPaymentMethodList } from "@/api/order";
import { useShopStoreWithOut } from "@/store/shopStore";
import SvgIcon from "../base/SvgIcon.vue";
import { priceUtil } from "@op/shared";
import { mapStores } from "pinia";
import { useUserStore } from "@/store/userStore";
import { nextTick } from "vue";
var sortPriorityMap = {
  balance: 11,
  online_payment: 10,
  // 预留给余额不足时余额的排序位置
  cod: 8
};
export default {
  props: {
    deliveryMethod: {
      type: String,
      default: ""
    },
    needShowMore: {
      type: Boolean,
      default: false
    },
    useType: {
      type: String,
      default: "order" // 使用类型,有'order'(下单)和'recharge'(充值)
    },
    shopId: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: Object,
      default: null
    },
    invalidMethodList: {
      type: Array,
      default: null
    }
  },
  emits: ["change"],
  data: function data() {
    return {
      selectedIndex: -1,
      options: [],
      isShowMore: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapStores(useUserStore)), {}, {
    onlinePaymentOptions: function onlinePaymentOptions() {
      return this.options.filter(function (item) {
        return item.method !== "cod" && item.method !== "balance";
      });
    },
    codPaymentOptions: function codPaymentOptions() {
      var _this = this;
      return this.options.filter(function (item) {
        return item.method === "cod";
      }).filter(function (option) {
        if (_this.invalidMethodList) {
          return !_this.invalidMethodList.includes(option.method);
        } else {
          return true;
        }
      });
    },
    optionsShow: function optionsShow() {
      var _this2 = this;
      return (this.useType === "recharge" ? this.onlinePaymentOptions : this.options).filter(function (option) {
        if (_this2.invalidMethodList) {
          return !_this2.invalidMethodList.includes(option.method);
        } else {
          return true;
        }
      });
    }
  }),
  watch: {
    deliveryMethod: function deliveryMethod() {
      this.getPaymentConfig();
    },
    optionsShow: function optionsShow(newVal, oldVal) {
      var oldItem = oldVal[this.selectedIndex];
      var newIndex = newVal.findIndex(function (item) {
        return item.value === (oldItem === null || oldItem === void 0 ? void 0 : oldItem.value);
      });
      if (newIndex === -1) {
        this.selectHandler(-1, true);
      } else {
        this.selectHandler(newIndex);
      }
    }
  },
  created: function created() {
    this.getPaymentMethod();
    if (this.needShowMore) {
      this.isShowMore = false;
    }
  },
  methods: {
    formatPrice: function formatPrice(price, currency) {
      return priceUtil.formatBaseUnitToShowPrice(price, currency);
    },
    getPaymentMethod: function getPaymentMethod() {
      var _this3 = this;
      var shopStore = useShopStoreWithOut();
      getPaymentMethodList({
        shop_id: this.shopId || shopStore.getShopId,
        delivery_method: this.deliveryMethod
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          var _res$data;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!Array.isArray(res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.payment_method_list)) {
                  _context.next = 5;
                  break;
                }
                if (!res.data.payment_method_list.find(function (item) {
                  return item.method === "balance";
                })) {
                  _context.next = 4;
                  break;
                }
                _context.next = 4;
                return _this3.userStore.setUserAsset();
              case 4:
                // options处理
                _this3.options = res.data.payment_method_list.filter(function (x) {
                  return !["iyzico"].includes(x.platform);
                }) // 暂时不实现iyzico
                .map(function (x) {
                  var _info$cc, _info$en, _info$cc2, _info$en2;
                  var needRedirect = ["razer", "ghl", "payments_hub"].includes(x.platform);
                  var info = x.info ? Object.fromEntries(x.info.map(function (y) {
                    return [y.languageCode, y];
                  })) : {};
                  var cc = (shopStore.getCountry || "en").toLowerCase();
                  var success_url = "".concat(window.location.origin).concat(window.location.pathname, "#").concat(_this3.useType === "recharge" ? "/recharge?id=${record_id}&callback=1" : "/home/order?id=${order_id}&callback=1");
                  var cancel_url = "".concat(window.location.origin).concat(window.location.pathname, "#").concat(_this3.useType === "recharge" ? "/recharge?id=${record_id}&callback=1" : "/home/order?id=${order_id}&callback=1");
                  return {
                    platform: x.platform,
                    value: x.id,
                    method: x.method,
                    text: ((_info$cc = info[cc]) === null || _info$cc === void 0 ? void 0 : _info$cc.name) || ((_info$en = info.en) === null || _info$en === void 0 ? void 0 : _info$en.name) || x.name,
                    isCardType: false,
                    needRedirect: needRedirect,
                    leftIcon: ((_info$cc2 = info[cc]) === null || _info$cc2 === void 0 ? void 0 : _info$cc2.icon) || ((_info$en2 = info.en) === null || _info$en2 === void 0 ? void 0 : _info$en2.icon) || "",
                    success_url: success_url,
                    cancel_url: cancel_url,
                    subCharge: x.sub_charge
                  };
                }).sort(function (a, b) {
                  var bSort = b.method === "balance" && _this3.userStore.getWallet <= 0 ? 9 : sortPriorityMap[b.method];
                  var aSort = a.method === "balance" && _this3.userStore.getWallet <= 0 ? 9 : sortPriorityMap[a.method];
                  return bSort - aSort;
                });
              case 5:
                // 等待this.optionsShow计算完
                nextTick(function () {
                  if (_this3.optionsShow.length > 0) {
                    var defaultIndex = _this3.optionsShow.findIndex(function (item) {
                      var _this3$defaultValue;
                      return item.value === ((_this3$defaultValue = _this3.defaultValue) === null || _this3$defaultValue === void 0 ? void 0 : _this3$defaultValue.value);
                    });
                    if (defaultIndex !== -1) {
                      _this3.selectHandler(defaultIndex);
                    } else {
                      _this3.selectHandler(0);
                    }
                  }
                });
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    selectHandler: function selectHandler(index, allowUnselect) {
      this.selectedIndex = index;
      var paymentMethod = this.optionsShow[this.selectedIndex];
      if (paymentMethod) {
        this.$emit("change", paymentMethod);
      } else if (allowUnselect) {
        this.$emit("change", null);
      }
    },
    handleShowMore: function handleShowMore() {
      this.isShowMore = true;
    }
  }
};